import util from '../util'

let base= window.$servicePath;

export default {
  listJob(){
    return util.ajax(`${base}/api/job/listJob`)
  },
  getJob(id){
    return util.ajax(`${base}/api/job/getJob`, id)
  },
  //创建定时任务组件
  createQuatzComponent(params) {
    return util.ajax(`${base}/api/job/createQuatzComponent`, params)
  },
  removeQuatzComponent(params){
    return util.ajax(`${base}/api/job/removeQuatzComponent`,params)
  },
  getQuatzComponent(id) {
    return util.ajax(`${base}/api/job/getQuatzComponent`, id)
  },
  execJob(params){
    return util.ajax(`${base}/api/job/execJob`, params)
  },
  suspendJob(params) {
    return util.ajax(`${base}/api/job/suspendJob`, params)
  },
  resumeJob(params) {
    return util.ajax(`${base}/api/job/resumeJob`, params)
  }
}



// WEBPACK FOOTER //
// ./src/common/api/job.js